export const addSuffixToFieldName = (fieldName: string, suffix: string) =>
  fieldName.endsWith(']')
    ? `${fieldName.slice(0, -1)}${suffix}]`
    : `${fieldName}${suffix}`;
